import PropTypes from "prop-types"
import React, { useContext, useEffect, useState } from "react"
import { AuthContext } from "../context/auth"
import { makeStyles } from "@material-ui/core/styles"
import {
  AppBar,
  Toolbar,
  IconButton,
  Button,
  Fade,
  Backdrop,
  Modal,
} from "@material-ui/core"
import MenuIcon from "@material-ui/icons/Menu"
import ChatIcon from "@material-ui/icons/Chat"
import publicIp from "public-ip"
import firebase from "gatsby-plugin-firebase"
import { graphql, useStaticQuery, navigate } from "gatsby"
import axios from "axios"
// import ConvertirZonaHoraria from "../components/Utiles/ConvertirZonaHoraria"

//const drawerWidth = 240

const useStyles = makeStyles(theme => ({
  /*     alturaDeHeader: {
      altoHeader: theme.mixins.Toolbar
    } , */
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2), //uso nombre que quiera
  },
  title: {
    flexGrow: 1,
  },
  AppBar: {
    /*   [theme.breakpoints.up('sm')]: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth
   } */
    width: 100, //antes del cambio por el CHAT
    // width: "100%",
    left: 0,
    backgroundColor: "transparent",
    boxShadow: "none",
    margin: 0,
    padding: 0,
  },
  AppBarChat: {
    width: 100,
    right: 0,
    backgroundColor: "transparent",
    boxShadow: "none",
    margin: 0,
    padding: 0,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}))

const Header = props => {
  const { configuracion } = useStaticQuery(graphql`
    query {
      configuracion: strapiConfiguracion {
        notificacionActiva
        gpsUsuariosActivo
        gps_link_planilla
        zona_horaria
        chat
        chat_link
        chat_opciones {
          left
          top
          height
          width
          resizable
          scrollbars
        }
      }
    }
  `)

  const classes = useStyles()
  const { user } = useContext(AuthContext)

  const getClientIp = async () =>
    await publicIp.v4({
      fallbackUrls: ["https://ifconfig.co/ip"],
    })
  const [ip, setIp] = useState("")
  useEffect(() => {
    getClientIp().then(result => setIp(result))
  }, [])

  useEffect(() => {
    if (user && ip !== "") {
      //console.log(user.uid)
      const useruid = user.uid
      ipUsuario({ useruid, ip })
    }
  }, [ip])

  const handleLogOut = async () => {
    await firebase.auth().signOut()
    navigate("/")
  }
  const [docUsuario, setDocUsuario] = useState({})
  const ipUsuario = ({ useruid, ip }) => {
    firebase
      .firestore()
      .collection("usuarios")
      .doc(useruid)
      .onSnapshot(function (doc) {
        if (doc.exists) {
          if (doc.data().front !== true) {
            navigate("/mis_datos")
          }
          setDocUsuario(doc.data())
          // localStorage.setItem("uid", doc.id)
          localStorage.setItem("nombre", doc.data().nombre)
          localStorage.setItem("apellido", doc.data().apellido)
          localStorage.setItem("espago", doc.data().espago)
          localStorage.setItem("email", doc.data().email)
          // localStorage.setItem("telefono", doc.data().telefono)
          // localStorage.setItem("whatsapp", doc.data().whatsapp)
          // localStorage.setItem("ramo", doc.data().ramo)
          // localStorage.setItem("pais", doc.data().pais)
          // localStorage.setItem("ciudad", doc.data().ciudad)
          // localStorage.setItem("empresa", doc.data().empresa)
          // localStorage.setItem("cargo", doc.data().cargo)
          // localStorage.setItem("interesado", doc.data().interesado)
          // localStorage.setItem("categoria", doc.data().categoria)
          // localStorage.setItem("chat", doc.data().chat)
          // localStorage.setItem("logo", doc.data().logo)
          // localStorage.setItem("ip", ip)
          //localStorage.setItem("registradoRonda", doc.data().registradoRonda)

          if (doc.data().ip !== ip) {
            handleLogOut()
          }
        } else {
          navigate("/mis_datos")
        }
      })
  }
  /** NOTIFICACIONES */
  //const notificacionActiva = false
  // cuando esta en false no anda el registro
  //no graba documento de firebase

  const [open, setOpen] = useState(false)
  const [notificacion, setNotificacion] = useState({})

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    localStorage.setItem("contadorNotificacion", notificacion.contador)
  }

  useEffect(() => {
    if (configuracion.notificacionActiva) {
      firebase
        .firestore()
        .collection("notificaciones")
        .doc("notificacion")
        .onSnapshot(function (doc) {
          if (doc.exists) {
            if (doc.data().mostrar) {
              setNotificacion(doc.data())
              if (
                localStorage.getItem("contadorNotificacion") ==
                doc.data().contador
              ) {
                // con == comparo valor
              } else {
                handleOpen()
              }
            }
          }
        })
      // console.log("esta on")
    } else {
      //  console.log("esta off")
      return
    }
  }, [])

  const irA = () => {
    handleClose()
    if (notificacion.tipo_link === "interno") {
      navigate(notificacion.link)
    } else {
      window.open(notificacion.link, "_blank")
    }
  }
  /** GPS usuarios */
  const ConvertirZonaHoraria = () => {
    let date = new Date()
    function convertTZ(date, tzString) {
      return new Date(
        (typeof date === "string" ? new Date(date) : date).toLocaleString(
          "en-US", // TODO ver si esto tambien viene del strapi
          { timeZone: tzString }
        )
      )
    }
    let convertida = convertTZ(date, configuracion.zona_horaria)
    // let convertida = convertTZ(new Date(), configuracion.zona_horaria)
    let dateConvertida =
      // convertida.getDate() +
      ("0" + convertida.getDate()).slice(-2) +
      "/" +
      ("0" + (convertida.getMonth() + 1)).slice(-2) +
      // (convertida.getMonth() + 1) +
      "/" +
      convertida.getFullYear()

    let timeConvertida =
      ("0" + convertida.getHours()).slice(-2) +
      // convertida.getHours() +
      ":" +
      ("0" + convertida.getMinutes()).slice(-2) +
      // convertida.getMinutes() +
      ":" +
      // convertida.getSeconds()
      ("0" + convertida.getSeconds()).slice(-2)

    return dateConvertida + " " + timeConvertida
  }
  useEffect(() => {
    if (configuracion.gpsUsuariosActivo) {
      if (user != null && window.location.pathname != "/") {
        let today = new Date()
        let date =
          today.getDate() +
          "/" +
          (today.getMonth() + 1) +
          "/" +
          today.getFullYear()

        let time =
          today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds()

        let gpsSubir = {
          url: window.location.pathname,
          email: user.email,
          nombre: docUsuario.nombre,
          apellido: docUsuario.apellido,
          hora: time,
          fecha: date,
          gmt: Date.now().toString(),
          zona_horaria_cliente: ConvertirZonaHoraria(),
          ip: docUsuario.ip,
        }
        axios
          .post(configuracion.gps_link_planilla, gpsSubir)
          .catch(error => {
            console.error("Error enviando GPS a planilla", error)
          })
        // axios.post("https://servidor.virtualeventweb.com:1340/plataforma-gps", {
        //   url: window.location.pathname,
        //   email: user.email,
        //   fecha: Date.now().toString(),
        //   ip: localStorage.getItem("ip"),
        //   uid: user.uid,
        //   nombre: localStorage.getItem("nombre"),
        //   apellido: localStorage.getItem("apellido"),
        // })
      }
    }
  }, [])
  /** GPS usuarios */

  const abrirVentanaNueva = () => {
    window.open(
      // "https://www.virtualeventweb.com",
      `${configuracion.chat_link}${user.uid}`,
      "windowOpenTab",
      // "scrollbars=1,resizable=1,width=1000,height=580,left=100,top=100"
      `scrollbars=${configuracion.chat_opciones.scrollbars ? 1 : 0},
      resizable=${configuracion.chat_opciones.resizable ? 1 : 0},
      width=${configuracion.chat_opciones.width},
      height=${configuracion.chat_opciones.height},
      left=${configuracion.chat_opciones.left},
      top=${configuracion.chat_opciones.top}`,
    )
  }

  /** NOTIFICACIONES */
  if (configuracion.notificacionActiva) {
    return (
      <header>
        <div className={classes.root}>
          {user ? (
            <>
              <AppBar position="fixed" className={classes.AppBar}>
                <Toolbar>
                  <IconButton
                    aria-label="menu"
                    edge="start"
                    className={classes.menuButton}
                    color="inherit"
                    onClick={() => props.accionAbrir()}
                    style={{
                      color: "#064dae",
                      background: "#ffffff",
                      padding: 14,
                      borderRadius: 60,
                    }}
                  >
                    <MenuIcon />
                    {/* Menu */}
                  </IconButton>
                  <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    className={classes.modal}
                    //  disableBackdropClick={false}
                    open={open}
                    // onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                      timeout: 500,
                    }}
                  >
                    <Fade in={open}>
                      <div className={classes.paper}>
                        <Button type="button" onClick={handleClose}>
                          X
                        </Button>
                        <h2 id="transition-modal-title">
                          {notificacion.titulo}
                        </h2>
                        <p id="transition-modal-description">
                          {notificacion.texto}
                        </p>
                        <Button
                          // style={{ background: `${color_fondo_marco}`, padding: 15 }}
                          type="button"
                          onClick={irA}
                        >
                          {notificacion.texto_link}
                        </Button>
                      </div>
                    </Fade>
                  </Modal>
                </Toolbar>
              </AppBar>
              {configuracion.chat ? (
                <AppBar position="fixed" className={classes.AppBarChat}>
                  <IconButton
                    aria-label="chat"
                    edge="start"
                    className={classes.menuButton}
                    color="inherit"
                    onClick={() => abrirVentanaNueva()}
                    // onClick={() => props.accionAbrirChat()}

                    style={{
                      color: "#064dae",
                      background: "#ffffff",
                      padding: 14,
                      borderRadius: 60,
                      position: "absolute",
                      top: 3,
                      right: 0,
                    }}
                  >
                    <ChatIcon />
                  </IconButton>
                </AppBar>
              ) : (
                ""
              )}
            </>
          ) : (
            <div></div>
          )}
        </div>
      </header>
    )
  } else {
    return (
      <header>
        <div className={classes.root}>
          {user ? (
            <>
              <AppBar position="fixed" className={classes.AppBar}>
                <Toolbar>
                  <IconButton
                    aria-label="menu"
                    edge="start"
                    className={classes.menuButton}
                    color="inherit"
                    onClick={() => props.accionAbrir()}
                    style={{
                      color: "#064dae",
                      background: "#ffffff",
                      padding: 14,
                      borderRadius: 60,
                    }}
                  >
                    <MenuIcon />
                    {/* Menu */}
                  </IconButton>
                </Toolbar>
              </AppBar>
              {configuracion.chat ? (
                <AppBar position="fixed" className={classes.AppBarChat}>
                  <IconButton
                    aria-label="chat"
                    edge="start"
                    className={classes.menuButton}
                    color="inherit"
                    onClick={() => props.accionAbrirChat()}
                    style={{
                      color: "#064dae",
                      background: "#ffffff",
                      padding: 14,
                      borderRadius: 60,
                      position: "absolute",
                      top: 3,
                      right: 0,
                    }}
                  >
                    <ChatIcon />
                    {/* Menu */}
                  </IconButton>
                </AppBar>
              ) : (
                ""
              )}
            </>
          ) : (
            <div></div>
          )}
        </div>
      </header>
    )
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
